import axios from 'axios';

export const customerApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/customers`,
    headers: {
        'Content-Type': 'application/json'
    }
})
